import React from 'react';
import { Element, Link } from 'react-scroll';
import { map } from 'lodash';
import { rem } from 'polished';
import styled from 'styled-components';

import { isBlank } from 'helpers/utils';
import type { Faq } from 'types/entities/faq';
import CollapseText from 'components/CollapseText/CollapseText';
import Content from 'components/Content/Content';
import RichTextEditor from 'components/GenericTextarea/RichTextEditor';
import { fromHTML } from 'components/GenericTextarea/utils';
import Margin from 'components/Margin/Margin';

import { headerHeightSticky, Nav, NavItem, Section, Wrapper } from '../ContentWithSidebar/styled';

const SectionHeader = styled.h2`
  margin-top: 0;
  margin-bottom: ${rem(20)};
  font-size: ${({ theme }) => theme.fontSizes.mediumLg};
  font-family: ${({ theme }) => theme.fontFamilies.sec};
  font-weight: ${({ theme }) => theme.fontWeights.secNormal};
`;

const SectionInner = styled(Element)`
  &:not(:last-child) {
    margin-bottom: ${rem(40)};
  }
`;

interface Props {
  faq: Faq;
}

const ContentToggleWithSidebar = ({ faq }: Props) => (
  <Wrapper>
    <Nav>
      {map(faq.faqSections, ({ title }, sectionIndex) => (
        <NavItem key={title}>
          <Link
            activeClass="active"
            to={`section${sectionIndex}`}
            offset={-headerHeightSticky}
            smooth
            spy
          >
            {title}
          </Link>
        </NavItem>
      ))}
    </Nav>

    <Section>
      {map(
        faq.faqSections,
        ({ title: sectionTitle, description: sectionDescription, faqQuestions }, sectionIndex) => (
          <SectionInner key={sectionTitle} name={`section${sectionIndex}`}>
            <SectionHeader>
              {sectionIndex + 1}. {sectionTitle}
            </SectionHeader>

            {map(faqQuestions, ({ title: questionTitle, description: questionDescription }) =>
              isBlank(questionTitle) || isBlank(questionDescription) ? null : (
                <CollapseText
                  key={questionTitle}
                  title={questionTitle}
                  description={
                    <RichTextEditor
                      value={fromHTML(questionDescription)}
                      minVerticalSize={null}
                      hasNoPadding
                      readOnly
                      transparent
                    />
                  }
                />
              )
            )}

            {sectionDescription && (
              <Margin top={20}>
                <Content>
                  <RichTextEditor
                    value={fromHTML(sectionDescription)}
                    minVerticalSize={null}
                    hasNoPadding
                    readOnly
                    transparent
                  />
                </Content>
              </Margin>
            )}
          </SectionInner>
        )
      )}
    </Section>
  </Wrapper>
);

export default ContentToggleWithSidebar;
